export default __webpack_public_path__ + "static/img_2_0-4ad1798905e1e958282ddb17d33b0c43.jpg";